import { getOrdersOrderIdTimeline } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

const ORDER_TIMELINE = "ORDER_TIMELINE";
export const getOrderTimelineQueryKey = (orderId: number) => {
	return [ORDER_TIMELINE, orderId];
};

export function useOrderTimelineQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderTimelineQueryKey(orderId),
		queryFn: processResponse(() => getOrdersOrderIdTimeline(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
